import ReactDOM from "react-dom/client";
import App from "./router";
import "../assets/global.css";
import "../assets/hamburger.css";
import { init as SentryInit, Sentry } from "@/lib/monitoring/sentry";
import { getFirebaseApp } from "@/lib/firebase";
import { initHotjar } from "@/lib/monitoring/hotjar";
import { PosthogAnalytics } from "@/lib/monitoring/posthog";
import { initRudder } from "@/lib/rudderstack/index.web";
import { getPlatform } from "@/lib/utils";

SentryInit();
Sentry.setTag("route.platform", getPlatform());
getFirebaseApp();
initHotjar();
PosthogAnalytics.init();
initRudder();

const el = document.getElementById("root");

if (!el) {
  throw new Error("Unable to find root element");
}

ReactDOM.createRoot(el).render(<App />);
